import React, { ReactChildren } from 'react';

import MyIcon from '../my-icon';

import style from './index.less';

export type BtnLinkProps = {
  type: string;
  className?: string;
  children?: ReactChildren | string;
  href?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
  disabled?: boolean;
  id?: string;
  noIcon?: boolean;
};

const BtnLink = ({ type = 'ecoboost-iconfontic_add', className = '', href = undefined, onClick = () => null, disabled = false, id, noIcon, children }: BtnLinkProps): JSX.Element | null => {

  const disabledProps = disabled ? { disabled: true } : {};

  return (
    <a id={id} href={href} onClick={onClick} className={`${className} ${style.btn_link}`} {...disabledProps}>
      {noIcon ? null : <MyIcon type={type} {...disabledProps} />}
      <span style={noIcon ? { color: '#1D2754' } : {}}>{children}</span>
    </a>
  );
};

export default BtnLink;
